import React, { useState } from "react";
import { SpaceSettingsDialog } from "../space-settings-dialog/space-settings-dialog.component";

export function useSpaceSettingsDialog() {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState<"profile" | "billing" | "team">("profile");

  const openDialog = (page: "profile" | "billing" | "team") => {
    setPage(page);
    setOpen(true);
  };

  const Dialog = (
    <SpaceSettingsDialog
      open={open}
      onOpenChange={setOpen}
      initialPage={page}
    />
  );

  return { openDialog, Dialog };
}
